import { IsoString } from 'models';
import {
	IClientInfo,
	IContract,
	ILogo,
	IMailingList,
	IOrganizationType,
} from '../../../models';
import { IClientLimits } from './IClientLimits';
import { IClientFormFields } from './IClientFormFields';

export interface IClientList extends Array<IClient> {}

export interface IClient extends IClientInfo {
	id: string;
	shortName: string;
	formalName: string;
	logoUrl: string;
	surveyCountLimit: number;
	surveyCount: number;
	contractStartDate: IsoString;
	contractEndDate: IsoString;
	contractUrl: string;
	domainName: string;
	website: string;
	deleted: boolean;
}

export interface ICompanyMailingList {
	mailingListKey: string;
	employeesCount: number;
	newEmployeesCount: number;
	totalEmployeesCount: number;
	dateAdded: string;
}

interface IClientDataBase extends IClientLimits {
	partnerId: string;
	id: string;
	formalName: string;
	shortName: string;
	domainName: string;
	comment?: string;
	color: string;
	website?: string;
	logo: ILogo;
	contractDto: IContract;
	mailListKey: string;
	clientCompanyMailingLists?: ICompanyMailingList[];
	hasOngoingSurveys: boolean;
	hasPlannedSurveys: boolean;
}

export interface IClientData extends IClientDataBase {
	organizationTypeDto: IOrganizationType;
}

export interface IClientDataPayload extends IClientDataBase {
	organizationIsicCode?: number;
	integrationId?: number;
}

export interface IClientFormData extends IClientForm {
	logoData: ILogo;
	contractData?: IContract;
	mailingListKeyData?: IMailingList | File;
	shouldDelete?: boolean;
	shouldUpdate?: boolean;
}

export interface IClientForm extends IClientLimits, IDynamicValidationFields {
	partnerId: string;
	id?: string;
	[IClientFormFields.formalName]: string;
	[IClientFormFields.shortName]: string;
	[IClientFormFields.domainName]: string;
	[IClientFormFields.website]?: string;
	[IClientFormFields.color]: string;
	[IClientFormFields.logo]: string;
	[IClientFormFields.organizationIsicCode]?: string;
	[IClientFormFields.comment]?: string;
	[IClientFormFields.mailingListKey]: string;
	[IClientFormFields.contractStartDate]?: string;
	[IClientFormFields.contractEndDate]?: string;
	[IClientFormFields.integrationId]?: string;
	[IClientFormFields.contract]?: string;
	hasOngoingSurveys: boolean;
	hasPlannedSurveys: boolean;
}

export enum DynamicValidationFieldNames {
	surveyMaxValue = 'surveyMaxValue',
}

export interface IDynamicValidationFields {
	[DynamicValidationFieldNames.surveyMaxValue]?: number;
}
